import az from '../JsonLang/az.json'
export const lang = { ...az }
